import { actionTypes } from '../actions/profiles';

// DEFAULT STATE
export const initProfiles = {
  profiles: [],
  selectedProfile: null,
  filterProfile: {
    completed: 'n',
  },
  sortBy: 'createdDate',
  sortDir: 'asc',
  pageNum: 0,
  stats: null,
};

// WRITES
const profiles = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_PROFILES:
      return Object.assign({}, state, {
        profiles: action.value,
      });
    case actionTypes.SET_SELECTED_PROFILE:
      return Object.assign({}, state, {
        selectedProfile: action.value,
      });
    case actionTypes.SET_FILTER_PROFILE:
      return Object.assign({}, state, {
        filterProfile: action.value,
      });
    case actionTypes.SET_SORT_BY:
      return Object.assign({}, state, {
        sortBy: action.value,
      });
    case actionTypes.SET_SORT_DIR:
      return Object.assign({}, state, {
        sortDir: action.value,
      });
    case actionTypes.SET_PAGE_NUM:
        return Object.assign({}, state, {
          pageNum: action.value,
        });
    case actionTypes.SET_STATS:
      return Object.assign({}, state, {
        stats: action.value,
      });
    case actionTypes.SET_UPDATE_IN_PROGRESS:
        return Object.assign({}, state, {
          updateInProgress: true,
        });
    case actionTypes.SET_UPDATE_COMPLETE:
        return Object.assign({}, state, {
          updateInProgress: false,
        });
    case actionTypes.UPDATE_PROFILE:

      // Filter out the profile that was updated
      const remainingProfiles = state.profiles.filter(d => d.id !== action.value.id);

      // Update the array of all profiles
      const updatedProfiles = [action.value].concat(remainingProfiles);

      return {
        ...state,
        profiles: updatedProfiles,
        selectedProfile: action.value,
      };

    default:
      return state;
  }
};

// READS
export const getProfiles = (state) => state.profiles.profiles;
export const getSelectedProfile = (state) => state.profiles.selectedProfile;
export const getFilterProfile = (state) => state.profiles.filterProfile;
export const getSortBy = (state) => state.profiles.sortBy;
export const getSortDir = (state) => state.profiles.sortDir;
export const getPageNum = (state) => state.profiles.pageNum;
export const getStats = (state) => state.profiles.stats;
export const getUpdateInProgress = (state) => state.profiles.updateInProgress;

export default profiles;
